export const GRAPH_PERMISSIONS = {
  GRAPH_READ: 'graphs:read',
  GRAPH_UPLOAD: 'graphs:upload',
} as const;
